import {
  PRIMARY_BLUE,
  GRAY_BACKGROUND,
  GRAY_DARK_SHADE_2,
  LIGHT_GRAY_BACKGROUND,
  WHITE,
} from '~/Constants/Colors.constants';
import { FONT_SIZE_LARGE, FONT_SIZE_SMALLISH } from '~/Constants/UI.constants';
import { makeStyles } from '~/UIKit/Style';
import { IImageStyle } from './useImageUploader';

export const ImageUploaderStyles = ({ width, height }: IImageStyle) =>
  makeStyles((theme) => ({
    imageUploaderWrapper: {
      paddingTop: theme.spacing(2),
      [theme.breakpoints.down('md')]: {
        padding: 0,
      },
    },
    title: {
      fontWeight: 'bolder',
      fontSize: FONT_SIZE_LARGE,
      marginBottom: theme.spacing(2),
      display: 'inline-flex',
      alignItems: 'center',
    },
    header: {
      marginBottom: theme.spacing(2),
    },
    image: {
      backgroundColor: LIGHT_GRAY_BACKGROUND,
      objectFit: 'scale-down',
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(1.5),
      width: width ? width : 100,
      height: height ? height : 100,
      [theme.breakpoints.down('md')]: {
        marginRight: theme.spacing(2.5),
        width: `calc(25vw - 81px)`,
        height: `calc(25vw - 81px)`,
      },
      [theme.breakpoints.down('md')]: {
        marginRight: theme.spacing(2.5),
        width: `calc(25vw - ${theme.spacing(3)}px)`,
        height: `calc(25vw - ${theme.spacing(3)}px)`,
      },
      '&.dragging': {
        border: `dashed 2px ${PRIMARY_BLUE}`,
        opacity: 0.4,
      },
    },
    imageContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
    },
    addImageArea: {
      backgroundColor: LIGHT_GRAY_BACKGROUND,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    uploadButton: {
      border: `1px solid ${PRIMARY_BLUE}`,
      backgroundColor: WHITE,
      width: 30,
      height: 30,
      color: PRIMARY_BLUE,
      borderRadius: '50%',
      minWidth: 'auto',
    },
    editButton: {
      border: `1px solid ${PRIMARY_BLUE}`,
      position: 'absolute',
      top: `calc(50% - ${theme.spacing(3)})`,
      left: `calc(50% - ${theme.spacing(3)})`,
      minWidth: 30,
      width: 30,
      height: 30,
      borderRadius: '50%',
      background: GRAY_BACKGROUND,
      [theme.breakpoints.down('md')]: {
        bottom: 30,
        right: 30,
      },
      '&:hover': {
        background: GRAY_DARK_SHADE_2,
      },
    },
    editButtonIcon: {
      fontSize: `${FONT_SIZE_SMALLISH}px!important`,
    },
    imageWrapper: {
      position: 'relative',
    },
  }));
